import {
	isSemanticSearchCalledAtom,
	semanticSearchStringAtom,
} from '@components/listings-search-bar/atoms';
import { useAtomValue } from 'jotai';
import React, { type FC, useMemo } from 'react';
import Title from '../../ResultsHeader/Title';
import Styles from './SemanticTitle.styles.scss';

export const SemanticTitle: FC = () => {
	const isSemanticSearchCalled = useAtomValue(isSemanticSearchCalledAtom);
	const semanticSearchString = useAtomValue(semanticSearchStringAtom);
	const shouldShowSemanticHeader = useMemo(() => {
		return isSemanticSearchCalled || semanticSearchString.trim().length > 0;
	}, [isSemanticSearchCalled, semanticSearchString]);

	return (
		<div className={Styles.semanticHeader}>
			{!shouldShowSemanticHeader && <Title />}
			{shouldShowSemanticHeader && (
				<Title inSemanticSearch semanticSearchString={semanticSearchString} />
			)}
		</div>
	);
};
